import { getPointerData } from './get-pointer-data';
/**
 * Get pointer/finger position
 */
export function getPosition(evt) {
    var data = getPointerData(evt);
    return {
        x: data.clientX,
        y: data.clientY,
    };
}
//# sourceMappingURL=get-position.js.map


//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_comments/node_modules/smooth-scrollbar/utils/get-position.js
// module id = 333
// module chunks = 0